import { render, staticRenderFns } from "./zxservice.vue?vue&type=template&id=e333bc5a&scoped=true"
import script from "./zxservice.vue?vue&type=script&lang=js"
export * from "./zxservice.vue?vue&type=script&lang=js"
import style0 from "./zxservice.vue?vue&type=style&index=0&id=e333bc5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e333bc5a",
  null
  
)

export default component.exports